<template>
    <div id="order-edit" class="container">
        <legend>Заказ №{{order.SferaNumber}}</legend>
        <div class="text-right">
            <button class="btn btn-secondary ml-3" type="button" @click.prevent="recastRequest">Запрос на переделку</button>
            <button class="btn btn-secondary ml-3" type="button" @click.prevent="print">Конверт</button>
        </div>
        <div class="mt-3">
            <div class="form-group row">
                <div class="col-lg-6">
                    <label>Клиент</label>
                    <input type="text" class="form-control form-control-sm" v-model="customer.Reception" readonly>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label>Объезд</label>
                    <input type="text" class="form-control form-control-sm" readonly :value="customer.PartnerTour.Name">
                </div>
                <div class="col-md-4 col-lg-2">
                    <label>Дни отправки</label>
                    <input type="text" class="form-control form-control-sm" readonly :value="clientSDays">
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Форма оплаты</label>
                    <input type="text" class="form-control form-control-sm" v-model="order.PaymentType.Name" readonly>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-12">
                    <label>Название заказа</label>
                    <input type="text" class="form-control form-control-sm" v-model="order.OptionNames" readonly>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-6">
                    <label>Артикул</label>
                    <input type="text" class="form-control form-control-sm" v-model="order.PartnerPriceName.Sku" readonly>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Цена</label>
                    <input type="number" class="form-control form-control-sm" v-model="order.Price" required autocomplete="disable"
                           v-on:keydown.enter.prevent readonly>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Количество</label>
                    <input type="number" class="form-control form-control-sm" v-model="order.Amount" required min="1"
                           autocomplete="disable" v-on:keydown.enter.prevent readonly>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Сумма за заказ</label>
                    <input type="number" class="form-control form-control-sm" v-model="order.Summary" required readonly
                           autocomplete="disable" v-on:keydown.enter.prevent>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-12">
                    <label>Дополнительные работы</label>
                    <input type="text" class="form-control form-control-sm" v-model="order.Dops" readonly>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6">
                    <label>От клиента</label>
                    <div>
                        <date-picker class="w-100" v-model="order.CustomerDate" valueType="format"
                                     :disabled="true"
                                     :first-day-of-week="1" lang="ru"></date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <label>Дата готовности</label>
                    <div>
                        <date-picker class="w-100" v-model="order.ReadyDate" valueType="format"
                                     :disabled="true"
                                     :input-attr="{required: true}"
                                     :first-day-of-week="1" lang="ru"></date-picker>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12 col-lg-6">
                    <label>Примечание</label>
                    <textarea cols="30" rows="3" v-model="order.Comment"
                              readonly
                              class="form-control form-control-sm"></textarea>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label>Номер клиента</label>
                    <input type="text" class="form-control form-control-sm" v-model="order.LocalNumber" v-on:keydown.enter.prevent
                           readonly>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="required">Номер сферы</label>
                    <input type="number" class="form-control form-control-sm" v-model="order.SferaNumber" required
                           readonly
                           v-on:keydown.enter.prevent>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12 col-lg-6">
                    <label>Дата доставки</label>
                    <input type="text" class="form-control form-control-sm" v-model="order.Delivery.DeliveryDate" v-on:keydown.enter.prevent
                           readonly>
                </div>
            </div>
        </div>
        <modals-container/>
    </div>
</template>

<script>
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import OrderPrintWrapper from '@/admin/components/OrderPrintWrapper.vue';
import RecastRequest from '@/admin/components/modals/RecastRequest.vue';


const url = `${process.env.VUE_APP_API_HOST}admin/order`;

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      recastRecastMessage: '',
      order: {
        PaymentType: {
          Name: '',
        },
        PartnerPriceName: {
          Sku: '',
        },
        Delivery: {
          DeliveryDate: '',
        },
      },
      customer: {
        PartnerTour: {
          Name: '',
        },
      },
    };
  },
  computed: {
    clientSDays() {
      if (!this.order.Partner) {
        return '';
      }
      const SDays = {
        SDay1: 'ПН',
        SDay2: 'ВТ',
        SDay3: 'СР',
        SDay4: 'ЧТ',
        SDay5: 'ПТ',
      };
      const SDaysActive = [];
      _.forEach(SDays, (value, key) => {
        if (this.order.Partner[key]) {
          SDaysActive.push(value);
        }
      });
      return SDaysActive.concat();
    },
  },
  async mounted() {
    await this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      const { data } = await axios.get(`${url}/${this.$route.params.orderId}`);
      const { order, customer } = data;
      this.order = Object.assign({}, this.order, order);
      this.customer = customer;
    },
    print() {
      this.$modal.show(OrderPrintWrapper, {
        order: this.order,
        customer: this.customer,
      }, {
        pivotY: 0.2,
        adaptive: true,
        width: '806px',
        height: '700px',
      });
    },
    recastRequest() {
      this.$modal.show(RecastRequest, {
        order: this.order,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      });
    },
  },
};
</script>
<style lang="scss">
#order-edit {
    label {
        margin-bottom: .1rem!important;
    }
    .form-group {
        margin-bottom: .3rem!important;
    }
}
</style>
